// extracted by mini-css-extract-plugin
module.exports = {"root":"components-ui-input-root","input":"components-ui-input-input","border":"components-ui-input-border"};